import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";

export interface MarkdownTextProps {
  value: string;
}

const MarkdownText = ({ value }: MarkdownTextProps) => {
  return (
    <div>
      <ReactMarkdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>
        {value}
      </ReactMarkdown>
    </div>
  );
};

export default MarkdownText;
